import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#F7F0E1] text-[#0A0A0A]">
      <div className="max-w-3xl mx-auto px-6 py-10">
        <Link
          to="/"
          data-testid="privacy-back"
          className="inline-flex items-center gap-2 text-sm text-[#6C6355] hover:text-[#B8912E] transition-colors"
        >
          <ArrowLeft size={16} /> Volver al inicio
        </Link>

        <h1 className="font-serif text-4xl md:text-5xl font-light mt-8 text-[#141210]">
          Política de privacidad
        </h1>
        <p className="text-[#6C6355] mt-3 text-sm">
          Última actualización: 16 de agosto de 2026
        </p>

        <div
          className="prose prose-sm max-w-none mt-8 text-[#0A0A0A] leading-relaxed space-y-5"
          data-testid="privacy-content"
        >
          <section>
            <h2 className="font-serif text-2xl text-[#141210] font-light">
              Responsable del tratamiento
            </h2>
            <p>
              Beatriz de Ibiza (en adelante «Bea de Ibiza»), responsable
              del tratamiento de los datos que nos facilitas al usar esta
              web. Para cualquier consulta relacionada con tus datos,
              puedes escribirnos por el chat de esta misma web o a través
              del número que aparece en la sección de contacto.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#141210] font-light">
              Datos que tratamos y con qué finalidad
            </h2>
            <ul className="list-disc ml-6 space-y-2">
              <li data-testid="privacy-sol-chat-data">
                <strong>Nombre y teléfono en el chat de Sol:</strong> los pedimos antes de empezar la conversación para saber quién ha consultado y poder revisarla si hace falta.
              </li>
              <li>
                <strong>Número de teléfono:</strong> lo utilizamos como
                identificador único de tu ficha de clienta. Sin él no
                podríamos gestionar tu reserva ni permitirte volver a
                consultarla o modificarla más adelante.
              </li>
              <li>
                <strong>Nombre:</strong> queda asociado a tu número de
                teléfono en tu ficha para poder dirigirnos a ti
                personalmente y para reconocerte en visitas posteriores.
                <strong>
                  {" "}
                  Cuando vuelvas a reservar desde el mismo teléfono, te
                  reconoceremos por tu nombre para saludarte;
                </strong>{" "}
                no arrastramos ni consultamos el contenido de
                conversaciones anteriores, solo el nombre y el histórico
                de reservas.
              </li>
              <li>
                <strong>Email (opcional):</strong> lo usamos únicamente
                para confirmarte la cita y para avisarte automáticamente
                cuando Bea vuelva de vacaciones si te has apuntado a la
                lista de espera.
              </li>
              <li>
                <strong>Conversaciones con los chats (Sol y el bot de
                reservas):</strong> se guardan durante 12 meses para
                poder ayudarte mejor en consultas posteriores. Junto a
                cada conversación guardamos también, durante el mismo
                plazo, unos metadatos técnicos internos (qué intención
                hemos detectado en cada mensaje y con qué grado de
                certeza) que nos sirven únicamente para mejorar la
                calidad del bot; no se comparten con terceros.
              </li>
              <li>
                <strong>Justificante de pago:</strong> se conserva
                mientras esté vigente cualquier obligación legal (mínimo
                6 años) por si hubiera que acreditar la transacción.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#141210] font-light">
              Base legal
            </h2>
            <p>
              El tratamiento se basa en tu consentimiento, que otorgas al
              introducir tu teléfono y continuar con la reserva. En lo
              que se refiere al justificante de pago, la base es también
              el cumplimiento de obligaciones legales tributarias.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#141210] font-light">
              Cesión a terceros
            </h2>
            <p>
              No compartimos tus datos con terceros para fines
              comerciales. Utilizamos Google Calendar como agenda para
              gestionar las citas y un proveedor de email para enviarte
              confirmaciones — sus datos se procesan en la Unión Europea
              o bajo acuerdos con garantías equivalentes.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#141210] font-light">
              Tus derechos
            </h2>
            <p>
              Puedes solicitar en cualquier momento el acceso, la
              rectificación o la eliminación de tus datos (incluyendo el
              vínculo nombre ↔ teléfono usado para reconocerte). Basta
              con escribirnos por el chat de esta web o al número de
              contacto — te atenderemos personalmente.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#141210] font-light">
              Conservación
            </h2>
            <p>
              Los datos de tu ficha (nombre y teléfono) se conservan
              mientras sigas siendo clienta activa o solicites su
              eliminación. Las conversaciones de los chats y sus
              metadatos técnicos internos se conservan 12 meses. Los
              justificantes de pago se conservan durante el plazo
              legal.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
